import React, { useState } from "react";
import { Award } from "lucide-react";
import PageHero from "../components/PageHero";
import Reveal from "../components/Reveal";
import { pageBanner } from "../mock";
import { translations } from "../translations";
import { useLanguage } from "../context/LanguageContext";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "../components/ui/dialog";

const initials = (name) => {
  const parts = name.replace(/\./g, "").trim().split(/\s+/);
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[parts.length - 1][0]).toUpperCase();
};

const Team = () => {
  const { lang } = useLanguage();
  const t = translations[lang];
  const [selected, setSelected] = useState(null);

  return (
    <div>
      <PageHero title={t.teamPage.pageTitle} image={pageBanner} />

      <section className="py-16 bg-white">
        <div className="max-w-[1000px] mx-auto px-5 lg:px-8 text-center">
          {t.teamPage.intro.map((p, i) => (
            <Reveal key={i} delay={i * 80}>
              <p className="text-slate-600 leading-relaxed mb-5">{p}</p>
            </Reveal>
          ))}
        </div>
      </section>

      <section className="pb-24 bg-white">
        <div className="max-w-[1280px] mx-auto px-5 lg:px-8">
          <Reveal className="text-center">
            <h2 className="font-serif text-3xl font-bold brand-navy dash-center">{t.teamPage.partnersLabel}</h2>
          </Reveal>
          <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-7 mt-14">
            {t.team.map((m, i) => (
              <Reveal key={m.id} delay={(i % 4) * 80}>
                <button
                  onClick={() => setSelected(m)}
                  className="group w-full text-center bg-[#f6f8f6] rounded-sm p-8 h-full border border-transparent hover:border-gold hover:shadow-lg transition-all duration-300"
                >
                  <div className="w-20 h-20 mx-auto rounded-full bg-steel text-white flex items-center justify-center font-serif text-2xl font-bold group-hover:bg-sky-accent transition-colors">
                    {initials(m.name)}
                  </div>
                  <h3 className="font-serif text-lg font-bold brand-navy mt-5">{m.name}</h3>
                  <p className="text-sky-accent text-sm font-medium mt-1">{m.title}</p>
                  <p className="text-slate-400 text-xs mt-2 leading-relaxed">{m.certs}</p>
                  <span className="inline-block text-sky-accent text-sm font-medium mt-4 group-hover:underline">
                    {t.ui.viewProfile}
                  </span>
                </button>
              </Reveal>
            ))}
          </div>
        </div>
      </section>

      <Dialog open={!!selected} onOpenChange={(o) => !o && setSelected(null)}>
        <DialogContent className="max-w-2xl p-0 overflow-hidden max-h-[90vh] overflow-y-auto">
          {selected && (
            <div className="p-8">
              <div className="flex items-center gap-4">
                <div className="w-16 h-16 shrink-0 rounded-full bg-steel text-white flex items-center justify-center font-serif text-xl font-bold">
                  {initials(selected.name)}
                </div>
                <div>
                  <DialogHeader>
                    <DialogTitle className="text-2xl font-bold brand-navy font-serif text-left">
                      {selected.name}
                    </DialogTitle>
                  </DialogHeader>
                  <p className="text-sky-accent font-medium mt-1">{selected.title}</p>
                </div>
              </div>

              <div className="mt-5 flex items-center gap-2">
                <Award size={15} className="text-sky-accent" />
                <span className="text-xs text-slate-500">{selected.certs}</span>
              </div>

              <div className="mt-5 space-y-4">
                {selected.bio.map((p, i) => (
                  <p key={i} className="text-slate-600 text-sm leading-relaxed">{p}</p>
                ))}
              </div>
            </div>
          )}
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default Team;
